<template>
    <div id="userList">
        <div class="search">
            <div class="block_box">
                <div class="p_select search_day_list" >
                    <div class="search_label">查询日期</div>
                    <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                        <el-date-picker
                                @change="getListData"
                                v-model="month"
                                type="month"
                                value-format="yyyy-MM"
                                prefix-icon="''"
                                class="datepicker"
                                placeholder="选择开始日期">
                        </el-date-picker>
                        <i class="el-icon-date" ref="iconDateStart"></i>
                    </div>
                </div>
                <div class="p_select">
                    <el-button class="search_btn" @click="getListData">查询</el-button>
                    <el-button class="add_btn" @click="exportTable('#dailyTestAndDeal')" >导出</el-button>
                </div>
            </div>
        </div>

        <div class="table">
            <el-table id="dailyTestAndDeal" :data="listData" :height=winHeight ref="table_1"
                      :span-method="objectSpanMethod"
                      :cell-style="cellStyle"
                      :header-cell-style="tableHeaderColor"
                      show-summary
                      :summary-method="getSummaries"
            >
                <el-table-column prop="categoryStr" label="类别" align="center"></el-table-column>
                <el-table-column prop="salesGroupName" label="项目" align="center"></el-table-column>
                <el-table-column prop="projectNo" label="编号" align="center"> </el-table-column>
                <el-table-column prop="projectName" label="项目名称" align="center"> </el-table-column>
                <el-table-column prop="price" label="到店价" align="center"> </el-table-column>
                <el-table-column :label="orgName"  align="center">
                    <el-table-column
                            prop="projectNum"
                            label="数量"
                            align="center">
                        <template slot-scope="scope">
                            <div v-for="orgItem in salesIncomeList" :key="orgItem.projectId">
                                <span v-if="orgItem.projectId=== scope.row.projectId ">{{orgItem.num}}</span>
                                <!--<span>{{orgItem.projectId}}{{orgItem.num}}</span>-->
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="projectIncome"
                            label="收入"
                            align="center">
                        <template slot-scope="scope">
                            <div v-for="orgItem in salesIncomeList" :key="orgItem.projectId">
                                <span v-if="orgItem.projectId=== scope.row.projectId ">{{orgItem.income}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="zip"
                            label="毛利率"
                            align="center">
                        <template slot-scope="scope">
                            <div v-for="orgItem in salesIncomeList" :key="orgItem.projectId">
                                <!--（收入-到店价*数量）/收入-->
                                <span v-if="orgItem.projectId=== scope.row.projectId ">{{orgItem.income > 0 && scope.row.price ?((orgItem.income - scope.row.price * orgItem.num) / orgItem.income).toFixed(2) : ''}}</span>
                            </div>
                        </template>
                    </el-table-column>

                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  export default {
    name: "detectionSummary",
    data(){
      return {
        orgId:'',
        orgName:'',
        month:'',
        winHeight:'200',

        salesCategory:[],
        listData:[],
        salesIncomeList:[],
        incomeSum:0,
        numSum:0,
      }
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if(signInfo.orgId > 0){
        this.orgId = signInfo.orgId
        this.orgName = signInfo.orgName
      }
      let obj = new Date();
      let month = obj.getMonth() + 1;
      if (month < 10) month = "0" + month;
      this.month = obj.getFullYear() + "-" + month

      this.allEnums();
      this.getListData()
    },
    methods:{
      onMouseOver(item) {
        this.$refs.iconDateStart.style.display = "none";
      },
      onMouseleave(item) {
        this.$refs.iconDateStart.style.display = "block";
      },
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }){
        if (columnIndex === 1) {
          const _row = (this.flitterData(this.listData ).one)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
      },
      flitterData(arr) {
        let spanOneArr = [],
          spanTwoArr = [],
          concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
            spanTwoArr.push(1);
          } else {
            if (item.salesGroupId === arr[index - 1].salesGroupId) { //第一列需合并相同内容的判断条件
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        })
        return {
          one: spanOneArr,
          two: spanTwoArr,
        }
      },

      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 2) {
            sums[index] = '品牌合计';
            return;
          }
          if (index === 5) {
            sums[index] = this.numSum;
            return;
          }
          if (index === 6) {
            sums[index] = this.incomeSum;
            return;
          }
        });

        return sums;
      },

      allEnums() {
        net.request("enum/allEnums", "get").then(res => {
          if (res.code === 0) {
            let salesCategory = res.data.SalesCategory
            this.salesCategory = salesCategory
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        });
      },
      getListData(){
        const params = {
          orgId: this.orgId,
          month: this.month
        }
        net.request("manage/salesIncome/getSalesIncomeReport", "post", null, params).then(res => {
            if(res.code === 0){
              let data = res.data.salesGroupList
              let salesIncomeList = res.data.salesIncomeList
              let salesCategory = this.salesCategory

              let listData = []
              data.forEach(item => {
                let salesProjectList = item.salesProjectList
                salesProjectList.forEach(i => {
                  i.salesGroupName = item.salesGroupName

                  let filterItem = salesCategory.filter(menuItem => {
                    return menuItem.value == i.category
                  })

                  i.categoryStr = filterItem.length>0 ? filterItem[0].desc :''

                })
                listData.push(...salesProjectList)
              })

              let numSum = 0
              let incomeSum = 0
              salesIncomeList.forEach(item => {
                numSum += item.num
                incomeSum += item.income
              })

              this.listData = listData.sort(this.compareAsc("projectId"));
              this.salesIncomeList = salesIncomeList
              this.numSum = numSum
              this.incomeSum = incomeSum

              const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
              this.winHeight = windiwHight  - 186;

            }
        })
      },

      // 导出数据
      exportTable(elTableId) {
        var wb = XLSX.utils.table_to_book(document.querySelector(elTableId));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "销售收入统计.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },

      // 排序 升序
      compareAsc: function(property) {
        return function (a, b) {
          const value1 = a[property];
          const value2 = b[property];
          return value1 - value2;
        }
      },


    },
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 24px;
        .search {
            background: #fff;
            padding-top: 24px;
            margin-bottom: 24px;
            display: flex;
            .block_box{
                width: 100%;
                .p_select {
                    display: flex;
                    margin: 0 24px 0px 0;
                    font-size: 12px;
                    float: left;
                    .search_label{
                        font-family: 'PingFang SC';
                        font-style: normal;
                        margin-right: 12px;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 40px;
                        color: #787E86;
                        white-space:nowrap
                    }

                    .el-input , .el-select{
                        width: 160px;
                    }
                }
                .search_btn {
                    background: #2B54FC;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;
                    color: #FFFFFF;
                    font-size: 14px;
                }
                .add_btn {
                    height: 38px;
                    background: rgba(148, 170, 204, 0.08);
                    border: 1px solid #2B54FC;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #2B54FC;
                }
            }
        }

    }
</style>
<style lang="less">
    .el-table .cell {

        white-space: pre-line;
    }
</style>
